import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-leo-inventory",
  "use": "icon-leo-inventory-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-leo-inventory\">\r\n<g transform=\"translate(-113.571 -113.571) scale(1.221818)\">\r\n<path d=\"M160 192h704v128H160V192zm0 192h704v448H160V384zm96 96v256h512V480H256z\" />\r\n  <path d=\"M352 544h64v96h-64v-96zm128 0h64v96h-64v-96zm128 0h64v96h-64v-96z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/leo-inventory.svg
// module id = 8tsV
// module chunks = 410